import requests from "./httpService";

const WebsiteServices = {


    getWebsiteDetail : async () =>{
        return requests.get(`/website`);
    },
    
    updateWebsiteDetail : async (id,body) =>{
 
        return requests.patch(`/website/${id}`,body);
    },



}

export default WebsiteServices;